import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { CheckoutTrackingStepOptionTypes } from '~app/modules/checkout/models';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';

export class CheckoutStepApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CheckoutStep;

  constructor(
    private hasFreightForwarding?: boolean,
    private validOffers?: CartOfferLine[],
    private actionField?: { step: string, option?: CheckoutTrackingStepOptionTypes }
  ) {

  }

  getPayload(): any {
    return {
      hasFreightForwarding: this.hasFreightForwarding,
      validOffers: this.validOffers || [],
      actionField: this.actionField || {}
    };
  }

  updateValidOffers(offers: CartOfferLine[]): void {
    this.validOffers = offers;
  }
}
